import { computed, type Ref } from 'vue'
import type { FileItem } from '@/common/types/fileItem'
import { attachmentUiRowKey } from '@/common/utils/fileAttachmentsUniData'
import {
  type AttachmentTapeBadgeUi,
  resolveAttachmentTapeRowBadge,
} from '@/common/utils/attachmentTapeRowStatus'

const EMPTY_UI: AttachmentTapeBadgeUi = {
  kind: 'none',
  visible: false,
  busy: false,
  clickBlocked: false,
  cssClass: '',
  iconClass: '',
  title: '',
  phase: null,
}

type UseAttachmentTapeBadgeOptions = {
  files: Ref<FileItem[]>
  resolveRowBadge: Ref<((file: FileItem) => AttachmentTapeBadgeUi) | undefined>
}

export function useAttachmentTapeBadge(options: UseAttachmentTapeBadgeOptions) {
  const uiByRowKey = computed(() => {
    const resolver = options.resolveRowBadge.value
    const map = new Map<string, AttachmentTapeBadgeUi>()
    if (!resolver) return map
    for (const file of options.files.value) {
      map.set(attachmentUiRowKey(file), resolver(file))
    }
    return map
  })

  function getBadgeUi(file: FileItem): AttachmentTapeBadgeUi {
    return uiByRowKey.value.get(attachmentUiRowKey(file)) ?? EMPTY_UI
  }

  return { getBadgeUi }
}
